import React from 'react'
import useUser from '../../hooks/useUser'
import { Show, ShowController, ShowButton, SimpleShowLayout, TextField, ReferenceManyField, Datagrid, FunctionField } from 'react-admin'
import { BackToOrgButton } from '../../components/Organization/OrgButtons.js'
import { parse } from "query-string";
import CustomShowActions from '../../components/CustomShowActions'

const UserShow = (props) => {
    const user = useUser()
    const { organization_id } = parse(props.location.search);
    return (
        <ShowController {...props}>
            {controllerProps =>
                <Show {...props} actions={<CustomShowActions overrideOrgID={organization_id} />} {...controllerProps} title="User Details">
                    <SimpleShowLayout>
                        <BackToOrgButton organization_id={organization_id} />
                        <TextField source="email" />
                        <TextField source="firstName" />
                        <TextField source="lastName" />
                        <TextField source="role" />
                        <FunctionField label="Last Signed In:" render={record => {
                            const  dateValue = record.lastSignedIn * 1 || 0
                            if (dateValue === 0) return 'N/A'
                            const date = new Date(dateValue);
                            return date.toString()
                        }}  />
                        <ReferenceManyField
                            label="Organizations"
                            reference="organizations"
                            target="UserId">
                            <Datagrid>
                                <TextField source="name" />
                                {user.role === 'super-admin' && <ShowButton />}
                            </Datagrid>
                        </ReferenceManyField>
                    </SimpleShowLayout>
                </Show>
            }
        </ShowController>
    )
}

export default UserShow